import { APP_THEME_STORAGE_KEY } from './tokens';

const SUPPORTED_THEME_MODES = ['light', 'dark', 'system'];
const DEFAULT_THEME_MODE = 'light';

export function normalizeThemeMode(themeMode) {
  if (typeof themeMode !== 'string') return null;

  const normalizedThemeMode = themeMode.toLowerCase();
  return SUPPORTED_THEME_MODES.includes(normalizedThemeMode) ? normalizedThemeMode : null;
}

export function getStoredThemeMode() {
  try {
    return normalizeThemeMode(localStorage.getItem(APP_THEME_STORAGE_KEY)) || DEFAULT_THEME_MODE;
  } catch (error) {
    return DEFAULT_THEME_MODE;
  }
}

export function getSystemMode() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return DEFAULT_THEME_MODE;
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export { DEFAULT_THEME_MODE, SUPPORTED_THEME_MODES };
